module.exports = __webpack_public_path__ + "img/rentals.86a283aa.jpg";